import { SHOP_TYPES as SHOP_TYPES_FROM_CONSTANTS } from '../../../constants/shopTypes';
import * as Yup from 'yup';

export const SHOP_TYPES = SHOP_TYPES_FROM_CONSTANTS;

export const PAYMENT_METHODS = [
  { label: 'Bank Transfer', value: 'bank' },
  { label: 'Credit Card', value: 'credit_card' },
  { label: 'Cash', value: 'cash' },
  { label: 'PayPal', value: 'paypal' },
  { label: 'Other', value: 'other' }
];

export const DAYS_OF_WEEK = [
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' }
];



export const SETUP_STEPS = {
  // Base steps for all business types
  base: [
    {
      label: 'Business Details',
      icon: 'pi pi-building',
      description: 'Provide your business details, contact info, and location'
    }
  ],
  additional: {
    // Service category
    'SV_cleaning': [
      {
        label: 'Service Area',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your cleaning service areas and specialties'
      }
    ],
    'SV_repairs': [
      {
        label: 'Repairs & maintenance',
        icon: 'pi pi-file-arrow-up',
        description: 'List your repair specialties and service areas'
      }
    ],
    'SV_beauty': [
      {
        label: 'Beauty Services',
        icon: 'pi pi-file-arrow-up',
        description: 'List your beauty treatments and services'
      }
    ],
    'SV_freelance': [
      {
        label: 'Consulting Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your consulting specialties and rates'
      }
    ],
    'SV_printing': [
      {
        label: 'Printing Services',
        icon: 'pi pi-file-arrow-up',
        description: 'List your printing capabilities and turnaround times'
      }
    ],
    'SV_events': [
      {
        label: 'Event Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your event services and packages'
      }
    ],

    // Food & Beverage category
    'FB_restaurant': [
      {
        label: 'Restaurant Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your restaurant specialties and dining options'
      }
    ],
    'FB_bakery': [
      {
        label: 'Bakery Details',
        icon: 'pi pi-file-arrow-up',
        description: 'List your bakery specialties and offerings'
      }
    ],
    'FB_catering': [
      {
        label: 'Catering Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your catering packages and specialties'
      }
    ],
    'FB_foodTruck': [
      {
        label: 'Food Truck Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your food truck menu and service areas'
      }
    ],
    'FB_bar': [
      {
        label: 'Bar Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your bar specialties and atmosphere'
      }
    ],

    // Retail category
    'RT_clothing': [
      {
        label: 'Fashion Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your clothing styles and sizes'
      }
    ],
    'RT_electronics': [
      {
        label: 'Electronics Details',
        icon: 'pi pi-file-arrow-up',
        description: 'List your electronic products and services'
      }
    ],
    'RT_grocery': [
      {
        label: 'Grocery Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your product categories and delivery options'
      }
    ],
    'RT_furniture': [
      {
        label: 'Furniture Details',
        icon: 'pi pi-file-arrow-up',
        description: 'List your furniture styles and customization options'
      }
    ],
    'RT_specialty': [
      {
        label: 'Specialty Shop Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your specialty products and services'
      }
    ],

    // Technology & Online category
    'TO_webDev': [
      {
        label: 'Web Development Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your web development services and specialties'
      }
    ],
    'TO_saas': [
      {
        label: 'SaaS Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your digital tool features and pricing'
      }
    ],
    'TO_ecommerce': [
      {
        label: 'E-commerce Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your online store categories and shipping options'
      }
    ],
    'TO_itServices': [
      {
        label: 'IT Services Details',
        icon: 'pi pi-file-arrow-up',
        description: 'List your IT service offerings and support options'
      }
    ],
    'TO_mobileApps': [
      {
        label: 'Mobile App Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your mobile app features and platforms'
      }
    ],

    // Health & Wellness category
    'HW_medical': [
      {
        label: 'Medical Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your medical specialties and services'
      }
    ],
    'HW_pharmacy': [
      {
        label: 'Pharmacy Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your pharmacy services and delivery options'
      }
    ],
    'HW_fitness': [
      {
        label: 'Fitness Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your fitness programs and facilities'
      }
    ],
    'HW_spa': [
      {
        label: 'Spa Services',
        icon: 'pi pi-file-arrow-up',
        description: 'List your spa treatments and packages'
      }
    ],
    'HW_mentalHealth': [
      {
        label: 'Mental Health Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your counseling and therapy services'
      }
    ],

    // Real Estate & Housing category
    'RE_rentals': [
      {
        label: 'Rental Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your rental properties and terms'
      }
    ],
    'RE_realEstate': [
      {
        label: 'Real Estate Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your real estate specialties and services'
      }
    ],
    'RE_interiorDesign': [
      {
        label: 'Design Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your interior design specialties and packages'
      }
    ],
    'RE_homeImprovement': [
      {
        label: 'Improvement Services',
        icon: 'pi pi-file-arrow-up',
        description: 'List your home improvement services and specialties'
      }
    ],

    // Transportation & Automotive category
    'TA_autoRepair': [
      {
        label: 'Auto Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your auto repair and detailing services'
      }
    ],
    'TA_carRental': [
      {
        label: 'Rental Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your rental vehicle options and terms'
      }
    ],
    'TA_logistics': [
      {
        label: 'Logistics Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your delivery and logistics capabilities'
      }
    ],
    'TA_bikeRental': [
      {
        label: 'Bike Rental Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your bike rental options and terms'
      }
    ],

    // Education & Training category
    'ED_schools': [
      {
        label: 'Education Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Setup your school/tutoring center details'
      }
    ],
    'ED_onlineCourses': [
      {
        label: 'Course Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Setup your online course details'
      }
    ],
    'ED_languageSchools': [
      {
        label: 'Language School Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Setup your language school details'
      }
    ],
    'ED_workshops': [
      {
        label: 'Workshop Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Setup your workshop details'
      }
    ],

    // Professional Services category
    'PS_legal': [
      {
        label: 'Legal Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your legal specialties and services'
      }
    ],
    'PS_accounting': [
      {
        label: 'Accounting Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your accounting specialties and services'
      }
    ],
    'PS_insurance': [
      {
        label: 'Insurance Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your insurance specialties and coverage options'
      }
    ],
    'PS_marketing': [
      {
        label: 'Marketing Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your marketing specialties and packages'
      }
    ],
    'PS_engineering': [
      {
        label: 'Engineering Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your engineering specialties and services'
      }
    ],
    'PS_consulting': [
      {
        label: 'Consulting Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your consulting specialties and services'
      }
    ],
    'PS_hr': [
      {
        label: 'HR Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your HR and staffing services'
      }
    ],

    // Entertainment & Leisure category
    'EL_gaming': [
      {
        label: 'Gaming Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your gaming specialties and services'
      }
    ],
    'EL_eventVenues': [
      {
        label: 'Venue Details',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your venue amenities and capacity'
      }
    ],
    'EL_arts': [
      {
        label: 'Arts Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your art, music, and theater offerings'
      }
    ],
    'EL_travel': [
      {
        label: 'Travel Services',
        icon: 'pi pi-file-arrow-up',
        description: 'Define your travel and tourism services'
      }
    ]
  }
};

export const INITIAL_VALUES = {
  shopName: '',
  shopType: [],
  storeAddress: '',
  directions: '',
  contactEmail: '',
  contactPhone: '',
  storeImages: [],
  paymentMethods: [],
  paymentUrls: {},
  markerPosition: null
};

export const VALIDATION_SCHEMA = Yup.object().shape({
  shopName: Yup.string()
    .required('Business name is required')
    .max(50, 'Business name must not exceed 50 characters'),
  contactEmail: Yup.string()
    .required('Email is required')
    .email('Invalid email format')
    .max(100, 'Email must not exceed 100 characters'),
  contactPhone: Yup.string()
    .required('Phone number is required')
    .max(20, 'Phone number must not exceed 20 characters'),
  markerPosition: Yup.object()
    .shape({
      lat: Yup.number().required('Please set your business location on the map'),
      lng: Yup.number().required('Please set your business location on the map')
    })
    .required('Please set your business location on the map'),
  storeAddress: Yup.string()
    .required('Address is required')
    .max(200, 'Address must not exceed 200 characters'),
  directions: Yup.string()
    .required('Directions is required')
    .max(150, 'Directions must not exceed 150 characters'),
  storeImages: Yup.array()
    .max(5, 'Maximum of 5 images allowed'),
  businessHours: Yup.array()
    .of(Yup.object().shape({
      day: Yup.string().required(),
      open: Yup.boolean().required(),
      openingTime: Yup.string()
        .when('open', {
          is: true,
          then: Yup.string().required('Opening time is required')
        }),
      closingTime: Yup.string()
        .when('open', {
          is: true,
          then: Yup.string().required('Closing time is required')
        })
    })),

  // Service category validations
  serviceAreas: Yup.string()
    .when('shopType', {
      is: (shopType) => ['SV_cleaning', 'SV_repairs'].includes(shopType?.[0]?.value),
      then: Yup.string().required('Service areas are required')
    }),
  specialties: Yup.string()
    .when('shopType', {
      is: (shopType) => ['SV_cleaning', 'SV_repairs', 'SV_beauty'].includes(shopType?.[0]?.value),
      then: Yup.string().required('Specialties are required')
    }),
  serviceRadius: Yup.number()
    .when('shopType', {
      is: (shopType) => ['SV_cleaning', 'SV_repairs'].includes(shopType?.[0]?.value),
      then: Yup.number().required('Service radius is required').min(0).max(100)
    }),

  // Repair specific validations
  repairTypes: Yup.string()
    .when('shopType', {
      is: (shopType) => shopType?.[0]?.value === 'SV_repairs',
      then: Yup.string().required('Repair types are required')
    }),

  // Beauty specific validations
  servicesOffered: Yup.string()
    .when('shopType', {
      is: (shopType) => shopType?.[0]?.value === 'SV_beauty',
      then: Yup.string().required('Services offered are required')
    }),
  appointmentHours: Yup.string()
    .when('shopType', {
      is: (shopType) => shopType?.[0]?.value === 'SV_beauty',
      then: Yup.string().required('Appointment hours are required')
    }),

  // Add other business type validations as needed
});
